import { useCallback, useEffect, useState } from "react";
import { api, formatError } from "@/lib/api";
import { toast } from "sonner";

/** Load, create and delete trips for the current user. */
export function useTrips() {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/trips");
      setTrips(data);
    } catch (e) {
      toast.error(formatError(e));
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const addTrip = useCallback((trip) => {
    setTrips((prev) => [trip, ...prev]);
  }, []);

  const removeTrip = useCallback(async (id) => {
    if (!window.confirm("Delete this trip and all its data?")) return false;
    try {
      await api.delete(`/trips/${id}`);
      setTrips((prev) => prev.filter((x) => x.id !== id));
      toast.success("Trip deleted");
      return true;
    } catch (e) {
      toast.error(formatError(e));
      return false;
    }
  }, []);

  return { trips, loading, addTrip, removeTrip };
}
